import classNames from "classnames/bind";
import styles from './PayForService.module.css';
import { BackIcon } from "../../../../components/Icons/Icons";
import CartDemo from '../../../../assets/images/QR-pay.png';
import { Link, useNavigate } from "react-router-dom";
import Button from "../../../../components/Button/Button";
import { Toast } from "../../../../components";
import { useStoreContext } from '../../../../hooks/useStoreContext';
import { actions } from "../../../../store";
import axiosClient from "../../../../services/axiosClient";

const cx = classNames.bind(styles)

function PayForService() {
    // eslint-disable-next-line 
    const [dataStore, dispatch] = useStoreContext()
    const navigate = useNavigate()
    const ticket = sessionStorage.getItem('packService')
    // // console.log('ticket', ticket);
    const data = JSON.parse(ticket)
    const handleSubmitPay = async () => {
        navigate('/admin/service', { state: { tabActive: 'pending' } })
        // try {
        //     const res = await axiosClient.post('/serviceRegister/post-buy-service/', {
        //         data
        //     })
        //     dispatch(actions.focusOnRedirect('pending'))
        //     Toast.open('Đăng ký thành công, chờ phê duyệt', 'success')
        //    sessionStorage.removeItem('packService')
        //     setTimeout(() => {
        //     }, 2000)
        //     return res
        // } catch (error) {
        //     Toast.open('Đăng ký không thành công!', 'danger')
        // }
    }
    return (
        <>
            <div id="__notification"></div>
            <div className={cx('header')}>
                <Link className={cx('button-back')} to={'/admin/service'}>
                    <BackIcon />
                    <h1 className={cx('user-name')}>
                        Thanh toán
                    </h1>
                </Link>
            </div>
            <div className={cx('container')}>
                <img className={cx('image-demo')} alt="cart-demo" src={CartDemo} />
                <div className={cx('ticket')}>
                    <h1 className={cx('user-name')}>Thông tin thanh toán</h1>
                    <div className={cx('info-box-content')}>
                        <div className={cx('item-info')}>
                            <p className={cx('label')}>Mã hoá đơn</p>
                            <p className={cx('content')}>019283</p>
                        </div>
                        <div className={cx('item-info')}>
                            <p className={cx('label')}>Ngân hàng</p>
                            <p className={cx('content')}>MB Bank</p>
                        </div>
                        <div className={cx('item-info')}>
                            <p className={cx('label')}>Tên chủ tài khoản</p>
                            <p className={cx('content')}>Cù Thị Chung</p>
                        </div>
                        <div className={cx('item-info')}>
                            <p className={cx('label')}>Số tài khoản</p>
                            <p className={cx('content')}>0123999999</p>
                        </div>
                        <div className={cx('item-info')}>
                            <p className={cx('label')}>Số tiền thanh toán</p>
                            <p className={cx('content')}>362.000 đ</p>
                        </div>
                        <div className={cx('item-info')}>
                            <p className={cx('label')}>Nội dung</p>
                            <p className={cx('content')}>thanh toan dich vu “Mã hoá đơn” cho Vinorsoft</p>
                        </div>
                        <div className={cx('pay-button')}>
                            <Button onClick={handleSubmitPay} title={'Cập nhập thanh toán'} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PayForService;